import { HttpError } from './HttpError.js';
export class ApiError extends HttpError {
    data;
    constructor(request, response, data) {
        super(request, response);
        this.data = data;
        this.name = 'ApiError';
    }
}
//# sourceMappingURL=ApiError.js.map